module.exports = __webpack_public_path__ + "img/9788983947147.e7281518.jpg";